import React from 'react';
import { Card, Text, Box, InlineGrid } from '@shopify/polaris';
import { FauxCard } from '#client/components/common/FauxCard/FauxCard';
import { useProgramMetrics, useProgramStore } from '#client/stores/program/useProgramStore';

export default function ProgramMetrics() {
    const { numberOfIssuedVouchers = 0, vouchersRedemptionRate = 0, totalMonetaryAmount = 0, totalNumberOfItemsRedeemed = 0 } = useProgramMetrics();

    const mode = useProgramStore.use.mode();
    if (mode === 'create') {
        return null; // Do not render metrics in create mode
    }

    return (
        <Card>
            <Box paddingBlock="400">
                <Box paddingBlock="400">
                    <Text variant="headingLg" as="h2">
                        Program Metrics
                    </Text>
                </Box>
                <InlineGrid columns={4} gap="400">
                    <FauxCard>
                        <Text>{numberOfIssuedVouchers}</Text>
                        <Text variant="headingSm" as="h2">
                            Number of Issued Vouchers
                        </Text>
                    </FauxCard>
                    <FauxCard>
                        <Text>{vouchersRedemptionRate}</Text>
                        <Text variant="headingSm" as="h2">
                            Vouchers Redemption Rate
                        </Text>
                    </FauxCard>
                    <FauxCard>
                        <Text>{totalMonetaryAmount}</Text>
                        <Text variant="headingSm" as="h2">
                            Total Monetary Amount
                        </Text>
                    </FauxCard>
                    <FauxCard>
                        <Text>{totalNumberOfItemsRedeemed}</Text>
                        <Text variant="headingSm" as="h2">
                            Total Number of Items Redeemed
                        </Text>
                    </FauxCard>
                </InlineGrid>
            </Box>
        </Card>
    );
}
